import { useState } from 'react';

const useHelpModal = () => {
  const [showWhyModal, setShowWhyModal] = useState(false);

  const openModal = () => setShowWhyModal(true);
  const closeModal = () => setShowWhyModal(false);
  const toggleModal = () => setShowWhyModal(prev => !prev);

  return {
    showWhyModal,
    setShowWhyModal,
    openModal,
    closeModal,
    toggleModal
  };
};

export default useHelpModal;
